import { createContext, type ReactNode, useContext } from "react";
import { createPortal } from "react-dom";
export const WorkspaceActionHost = createContext<HTMLElement | null>(null);
/** A real layout row outside the scrolling pane; it never overlays document content. */
export function WorkspaceActions({ children }: { children: ReactNode }) {
  const host = useContext(WorkspaceActionHost);
  const content = (
    <div
      className="flex flex-wrap items-center justify-end gap-3 border-t border-line bg-surface px-4 py-3 sm:px-6"
      data-component="WorkspaceActions"
    >
      {children}
    </div>
  );
  return host ? createPortal(content, host) : content;
}
